import { Action } from 'redux';

import { emit } from '../../lib/eventUtils';
import { getFreshAccount, clearIntent } from '../../lib/accountUtils';
import { m } from '../../lib/selectorUtils';
import { trackEvent, Event } from '../../lib/ga';
import { identifyOnce } from '../../lib/sendinblue';

import { Profile, SHOW_WELCOME } from '../../models/user';
import * as api from '../../lib/api/profile';

const AUTH_COMPLETED: Event = {
  category: 'AUTH',
  action: 'COMPLETED',
};

export const LOAD_USER = 'MODALS/LOAD_USER';
export const SAVE_USER = 'MODALS/SAVE_USER';
export const EDIT_USER = 'MODALS/EDIT_USER';

export type LoadUserActionPayload = Promise<Profile>;

export interface LoadUserAction extends Action {
  payload: LoadUserActionPayload;
}

export interface EditUserActionPayload {
  field: string;
  value: any;
}

export interface EditUserAction extends Action {
  payload: EditUserActionPayload;
}

export const loadUser = m(() => ({
  type: LOAD_USER,
  payload: Promise.all([api.getProfile(), api.getPreferenceDefinitions()]).then(
    ([profile, preferenceOptions]) => {
      const label = getFreshAccount();
      const data = { ...profile, preferenceOptions };

      if (profile.profile && profile.profile.email) {
        identifyOnce(profile.profile.email);
      }

      if (!label) return data;

      setTimeout(
        () => {
          emit('REDUX_INJECT', {
            type: SHOW_WELCOME,
            payload: {
              isFirstLogin: label === 'New',
            },
          });

          clearIntent();
          trackEvent({ ...AUTH_COMPLETED, label });
        },

        10
      );

      return data;
    }
  ),
}));

export const editUser = (field: string, value: any): EditUserAction => ({
  type: EDIT_USER,
  payload: { field, value },
});

export const saveUser = (data: Profile) => ({
  type: SAVE_USER,
  payload: api.saveProfile(data).then(profile => {
    return profile;
  }),
});
